var React = require('react');

function Calendar (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"calendar-today","transform":"translate(0)"},[React.createElement("path",{"id":"パス_600","data-name":"パス 600","d":"M21.186,22.873A1.686,1.686,0,1,0,19.5,21.186,1.686,1.686,0,0,0,21.186,22.873Z","transform":"translate(-11.069 -11.069)","fill":"#a6a6a6","key":0}),React.createElement("path",{"id":"パス_601","data-name":"パス 601","d":"M7.029,4.5A2.529,2.529,0,0,0,4.5,7.029V17.147a2.529,2.529,0,0,0,2.529,2.529H17.147a2.529,2.529,0,0,0,2.529-2.529V7.029A2.529,2.529,0,0,0,17.147,4.5ZM6.186,17.147V7.873h11.8v9.275a.843.843,0,0,1-.843.843H7.029A.843.843,0,0,1,6.186,17.147Z","transform":"translate(-4.5 -4.5)","fill":"#a6a6a6","fillRule":"evenodd","key":1})]));
}

Calendar.defaultProps = {"width":"1em","height":"1em","viewBox":"0 0 15.176 15.176","stroke":"currentcolor","fill":"currentcolor","strokeWidth":"0"};

module.exports = Calendar;

Calendar.default = Calendar;
